import { useQuery } from "@tanstack/react-query";
import { getAdminPayments } from "@/api/admin";
import { Card, SectionLabel } from "@/components/ui/Card";

export default function AdminPayments() {
  const q = useQuery({
    queryKey: ["admin-payments"],
    queryFn: getAdminPayments,
  });

  if (q.isLoading) return <div className="py-6 text-center text-taupe">Loading…</div>;
  if (!q.data) return <div className="py-6 text-center text-coral">Failed to load.</div>;

  return (
    <div className="space-y-4">
      <Card>
        <SectionLabel>Status</SectionLabel>
        <div className="mt-2 text-[14px] text-taupe">{q.data.message}</div>
      </Card>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <Card className="flex flex-col gap-1 px-4 py-3">
          <span className="section-label">MRR</span>
          <span className="metric-number text-[24px] text-taupe">
            ${q.data.mrr_usd}
          </span>
        </Card>
        <Card className="flex flex-col gap-1 px-4 py-3">
          <span className="section-label">ARR</span>
          <span className="metric-number text-[24px] text-taupe">
            ${q.data.arr_usd}
          </span>
        </Card>
      </div>
    </div>
  );
}
